import React from 'react'
import { useTranslation } from 'react-i18next'
import { workflowStatusService } from '../../services/workflow-status.service'
import { WorkflowStatus } from '../../types'
import { ManagementList } from '../common/ManagementList'
import { WorkflowStatusEditDialog } from './WorkflowStatusEditDialog'

export const WorkflowStatusList: React.FC = () => {
  const { t } = useTranslation()

  const getDeleteMessage = (item: WorkflowStatus) => {
    return t('document_workflow.statuses.confirm_delete', { name: item.name })
  }

  const extraColumns = [
    {
      key: 'color',
      name: t('color'),
      rendersHtml: true,
      valueFn: (item: WorkflowStatus) => {
        const textColor = item.text_color || '#ffffff'
        const bg = item.color || '#6c757d'
        return `<span class="badge" style="color: ${textColor}; background-color: ${bg}">${item.color}</span>`
      },
    },
  ]

  return (
    <ManagementList
      service={workflowStatusService}
      editDialogComponent={WorkflowStatusEditDialog}
      typeName={t('document_workflow.statuses.singular')}
      typeNamePlural={t('document_workflow.statuses.plural')}
      permissionType="workflow_status"
      extraColumns={extraColumns}
      getDeleteMessage={getDeleteMessage}
      info={t('document_workflow.statuses.info')}
      infoLink="workflow_statuses"
      hideMatchingColumn
      hidePermissionsButton
    />
  )
}
